import React from 'react';

const CalendarMinimalistic = ({ width = 20, height = 20, color = '#424242', ...rest }, ref) => {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      {...rest}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66406 10.0007C1.66406 6.85795 1.66406 5.28661 2.64037 4.3103C3.61668 3.33398 5.18803 3.33398 8.33073 3.33398H11.6641C14.8068 3.33398 16.3781 3.33398 17.3544 4.3103C18.3307 5.28661 18.3307 6.85795 18.3307 10.0007V11.6673C18.3307 14.81 18.3307 16.3814 17.3544 17.3577C16.3781 18.334 14.8068 18.334 11.6641 18.334H8.33073C5.18803 18.334 3.61668 18.334 2.64037 17.3577C1.66406 16.3814 1.66406 14.81 1.66406 11.6673V10.0007Z"
        stroke={color}
        strokeWidth="1.25"
      />
      <path d="M5.83594 3.33398V2.08398" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M14.1641 3.33398V2.08398" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
      <path d="M2.08594 7.5H17.9193" stroke={color} strokeWidth="1.25" strokeLinecap="round" />
    </svg>
  );
};

export default React.forwardRef(CalendarMinimalistic);
